import { FC, useEffect } from "react";

import { iApiConfig } from "../../../interfaces/interfaces";
import { blockchain, discountPercents, itemIds } from "../../../settings";
import { useStoreDispatch } from "../../../store/store";
import { connectKAS, getConfig } from "../../../utils/helpers";
import { getItems } from "../../../utils/Chromia/queries";
import { createStoreRecord } from "../../../utils/Chromia/utils";

import Loader from "../../Loader/Loader";

import './StartUpPage.scss';


const StartUpPage: FC = () => {

	const {setIsInited, setItems} = useStoreDispatch();

	useEffect(() => {
		switch (blockchain) {
			case 'binance':
				getConfigs();
				break;

			case 'chromia':
				initChr();
				break;

			default:
				throw new Error('');
		}
		// eslint-disable-next-line
	}, [])

	const getConfigs = async () => {
		let promises: Promise<iApiConfig>[] = [];
		discountPercents.forEach(percent => {
			promises.push(getConfig(percent));
		});
		/* const res =  */await Promise.allSettled(promises);
		setIsInited();
	}

	const initChr = async () => {
		// await connectKAS();
		const items = await getItems();	// wrap in trycatch - ?
		const foundItems = createStoreRecord(undefined, (ft, ut, perc) => {
			const foundItem = items.find(item => item.id === itemIds[ft][ut][perc]);
			if (!foundItem) throw new Error('Item not found');
			return foundItem;
		});
		setItems(foundItems);
		setIsInited();
	}


	return (
		<div className="StartUpPage">
			{/* Loading... */}
			<Loader/>
		</div>
	)
}

export default StartUpPage;